import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PostCreateJEAccrual } from 'domain/usecases';

import { RemoteCreateJEAccruals } from 'data/usecases';

export const makeRemoteCreateUpdateJeAccruals = (): PostCreateJEAccrual => {
  return new RemoteCreateJEAccruals(makeApiUrl('/journal-entries'), makeAuthorizeHttpClientDecorator());
};
